<template>
  <div class="product">
    <banner img="../assets/img/bgtop.jpg" title="智慧交通" />
	<div class="NewsDetails-product" v-loading="loading">
		<div class="content-nav">
			<div v-for="(item,index) in classList" class="content-nav-btn" :class="{'content-nav-active':item.id == pid}" @click="classChange(item)">
				<span>{{item.name}}</span>
			</div>
		</div>
		
		<div class="NewsDetails-product-content">
			<p class="product-title">{{newsIdList.title}}</p>
			<!-- <p class="product-time">{{newsIdList.createTime}}</p> -->
			<div id="editor-content-view" class="editor-content-view" v-html="newsIdList.content"></div>
		</div>
	</div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  data() {
    return {
      loading: false,
      pid: '',
      newsIdList: {},
	  name:'',
	  classList: [
		{ id:'58e39bb2-8d1c-4e2c-8477-89986f74cf50',name:'智慧治超'},
		{ id:'63779d4a-3588-4955-8855-d692fb65ef96',name:'科技示范路'}
		]
    };
  },
  components: {
    Banner
  },
  watch:{
	  $route(to,from){
		this.pid = to.params.id
		this.name = to.params.name 
		this.loadData()
	  },
  },
  created() {
    this.pid = this.$route.params.id
	this.name = this.$route.params.name 
    // window.console.log(this.pid);
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
		this.loading = true
		// this.$http.post('/oa/newcms/article/getDataByid',{id:this.pid})
		// .then(response => {
		// 	this.newsIdList = response.data.result
		// 	this.loading = false
		// 	// console.log(response)
		// })
		// .catch(error=> {
        
		// })
		this.$http({
			method: 'post',
			url: this.$baseURL + '/oa/newcmsArticle/getData',
			data: {
				id: this.pid
			}
		}).then(response => {
			this.newsIdList = response.data.result
			this.loading = false
		})
    },
	classChange(item){
		this.pid = item.id
		const currentPath = this.$route.fullPath
		const toPath = `/traffic/${item.id}/${item.name}`
		if(encodeURI(toPath) === currentPath) return
		this.$router.push({
			 name: 'traffic',
			 params:{
			  id:item.id,
			  name: item.name
			 }
		})
		// this.$router.push({name:'product',params: { id:item.id,name:item.name}})
	},
  }
};
</script>
<style lang="scss" scoped>
.NewsDetails {
  width: 100%;
  height: 100%;
  //overflow: hidden;
  &-product {
    width: 1240px;
    margin: 0 auto;
    background-color: #fff;
	
	.content-nav {
	  width: 400px;
	  height: 55px;
	  margin: 0 auto;
	  display: flex;
	  //justify-content: center;
	  align-items: center;
	  position: relative;
	  bottom: 30px;
	  border: 1px solid #bd282b;
	
	  &-btn {
		cursor: pointer;
		width: 50%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #e4e4e4;
		transition: all 0.2s;
	  }
	
	  .content-nav-active {
	    background-color: #bd282b;
	    color: #fff;
	  }
	}
	
    &-content {
      width: 100%;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 20px 0;
      img {
        width: 100%;
        //height: 500px;
      }
      .product-title {
		width: 100%;
		text-align: center;
		font-size: 25px;
        color: #e13834;
        padding: 15px 0;
      }
	  .product-time{
	      width: 100%;
		  margin-bottom: 10px;
		  text-align: right;
	  }
      .product-content {
        font-size: 17px;
        font-weight: bolder;
        padding: 20px 0;
      }
    }
  }
}
</style>